import { render, staticRenderFns } from "./BidDate.vue?vue&type=template&id=53758f70&scoped=true"
import script from "./BidDate.vue?vue&type=script&lang=js"
export * from "./BidDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53758f70",
  null
  
)

export default component.exports